import validationUtil from '../validation';

/**
 * @method - validation
 * @description - Validates the value of the related changed field and return an error.
 * NOTE: there are 2 kinds of validation, async and sync.
 * @param {string, string} key, value - Strings representing the key and value to validate.
 */
const useValidator = (onResult) => {
  const validate = (key, value, abslength) => {
    const errorResult = validationUtil(key, value, abslength);
    let resultPromise = errorResult;

    if (!errorResult) {
      onResult({
        key,
        value,
        error: ''
      });
      return;
    }

    if (typeof errorResult === 'string') {
      resultPromise = new Promise((_, reject) => reject(errorResult));
    }

    resultPromise
      .then(() => {
        onResult({
          key,
          value,
          error: ''
        });
      })
      .catch((error) => {
        if (typeof error === 'object') {
          onResult({
            key,
            value,
            error: error.error,
            data: error.data,
          });
        } else {
          onResult({
            key,
            value,
            error
          });
        }
      });
  };

  return {
    validate,
  };
};

export default useValidator;
